export default __webpack_public_path__ + "static/media/deauville01.5ce7d55b.jpg";